import { Responses500 } from '@consta/uikit/Responses500'

import type { ErrorComponent } from './types'

export const TabErrorElement: ErrorComponent = () => {
  return (
    <Responses500
      title="Что-то пошло не так"
      description="Попробуйте зайти позже"
      actions={<div />}
    />
  )
}
